import debounce from 'lodash/debounce';
import flatMap from 'lodash/flatMap';
import memoize from 'memoize-one';
import { arrayOf, bool, node, number, string } from 'prop-types';
import React from 'react';

import { gendersType } from '../../prop-types';
import api from '../../REST/api';
import join from '../../utils/join-h';

class MissingSKUs extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { message: '', loading: false };

    this.requestSkus = memoize(debounce(this.requestSkus.bind(this), 500));
  }

  componentDidMount() {
    this.checkSkus();
  }

  componentDidUpdate() {
    this.checkSkus();
  }

  checkSkus() {
    if (!this.props.check || this.state.loading) return;

    const { brandIds, categories, genders, countryCodes } = this.props;
    this.requestSkus(brandIds, categories, genders, ...countryCodes);
  }

  requestSkus(brandIds, categories, genders, ...countryCodes) {
    this.setState({ loading: true });

    const requests = flatMap(genders, gender =>
      countryCodes.map(country =>
        api
          .getSkus({
            brandIds,
            categories: categories.join(','),
            gender,
            country,
          })
          .then(
            response => ({ country, gender, skus: response }),
            error => ({ country, gender, skus: [], error }),
          ),
      ),
    );

    Promise.all(requests).then(results => {
      const missing = join(
        results
          .filter(result => result.skus.length === 0)
          .map(result => `${result.country} (for ${result.gender})`),
      );
      const message =
        missing.length > 0
          ? `There seem to be no SKUs for this quote line in ${missing}.`
          : '';
      this.setState({ message, loading: false });
    });
  }

  render() {
    const { check, children } = this.props;

    if (!check) {
      return children;
    }

    const { message, loading } = this.state;

    return React.Children.map(children, child =>
      React.cloneElement(child, {
        missingSKUsMessage: message,
        missingSKUsLoading: loading,
      }),
    );
  }
}

MissingSKUs.propTypes = {
  children: node.isRequired,
  check: bool,

  brandIds: arrayOf(number.isRequired).isRequired,
  categories: arrayOf(string.isRequired).isRequired,
  genders: gendersType.isRequired,
  countryCodes: arrayOf(string).isRequired,
};

MissingSKUs.defaultProps = {
  check: false,
};

export default MissingSKUs;
